<div mat-dialog-title>
  <div>{{ data.title }}</div>
</div>
<mat-divider></mat-divider>
<div mat-dialog-content>
  @if (data.line1) {
    <p class="line-1" [ngStyle]="data.line1Color && { color: data.line1Color }">
      {{ data.line1 }}
    </p>
  }
  @if (data.line2) {
    <p class="line-2" [ngStyle]="data.line2Color && { color: data.line2Color }">
      {{ data.line2 }}
    </p>
  }
  @if (data.line3) {
    <p class="line-3" [ngStyle]="data.line3Color && { color: data.line3Color }">
      {{ data.line3 }}
    </p>
  }
</div>
